export var colorPalette = {
    white: '#FFFFFF',
    black: '#000000',
    transparent: 'rgba(0,0,0,0)',
    // BASE MUI COLORS
    primary: {
        light: '#E8F0FA',
        main: '#146CD1',
        dark: '#0E4C92',
        contrast: '#ffffff',
        contrastDark: '#383838',
    },
    secondary: {
        light: '#D1333A',
        main: '#9E262B',
        dark: '#852024',
        contrast: '#ffffff',
        contrastDark: '#383838',
    },
    error: {
        light: '#F5E5E5',
        main: '#9E0505',
        dark: '#6F0404',
        contrast: '#F5E5E5',
        contrastDark: '#9E0505',
    },
    warning: {
        light: '#FCF7E5',
        main: '#E1AD01',
        dark: '#AE8600',
        contrast: '#FCF7E5',
        contrastDark: '#E1AD01',
    },
    info: {
        light: '#13293D',
        main: '#0B1824',
        dark: '#14293D',
        contrast: '#ffffff',
        contrastDark: '#ffffff',
    },
    success: {
        light: '#ECF4EB',
        main: '#3C9223',
        dark: '#2A6619',
        contrast: '#ECF4EB',
        contrastDark: '#3C9223',
    },
    // ADDITIONAL
    ink: {
        light: '#9C9C9C',
        main: '#383838',
        dark: '#606060',
        contrast: '#ffffff',
        contrastDark: '#383838',
    },
    pale: {
        light: '#707A83',
        main: '#33414E',
        dark: '#13293D',
        contrast: '#ffffff',
        contrastDark: '#383838',
    },
    cloud: {
        light: '#F6F9FC',
        main: '#C0D2E8',
        dark: '#146CD1',
        contrast: '#F6F9FC',
        contrastDark: '#146CD1',
    },
    smoke: {
        light: '#F2F3F5',
        main: '#D6D6D6',
    },
    ice: {
        main: '#E4EEFC',
        light: '#FFFFFFA3',
        dark: '#EEF5FF',
    },
    sky: {
        light: '#A3CEFF',
        main: '#469CFE',
    },
    purple: {
        main: '#AA4DF1',
        dark: '#FC03FF',
    },
    lila: {
        main: '#6C6FF8',
    },
    mint: {
        main: '#54E1C5',
    },
    scarlet: {
        main: '#D13239',
    },
    // Półprzezroczyste nakładki — cienie, gradienty oraz „szklane" tła i obramowania
    overlay: {
        whiteFaint: '#FFFFFF26', // 15% — tło chipów wariantu
        whiteSoft: '#FFFFFF33', // 20% — tło badge'y oferty
        whiteMuted: '#FFFFFF5E', // 37% — obramowanie chipów wariantu
        whiteStrong: '#FFFFFFC4', // 77% — obramowanie badge'y oferty
        blackFaint: '#00000029', // 16% — cień badge oprocentowania
        blackSoft: '#00000066', // 40% — cień kart widgetu
        blackMedium: '#00000099', // 60% — cień przycisku wariantu 5
        blackStrong: '#000000C4', // 77% — przyciemnienie gradientu tła
        blackScrim: '#000000B3', // 70,2% — dolna maska zdjęć (warianty w gridzie)
        navyStrong: '#012340ED', // 92,9% — lewa krawędź maski wariantu pełnoekranowego
        navyClear: '#06386000', // 0% — koniec poziomej maski (zachowuje granatowy odcień)
    },
};
